// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2024 Vic Zhu <viczhu2014@gmail.com>

/**
 * Virtual device constants for aggregating metrics from multiple devices
 */

export const VIRTUAL_DEVICE_PREFIX = 'all-devices-pet-'

/**
 * Generate a virtual device ID for a given pet
 */
export function getVirtualDeviceId(petId: string | number): string {
  return `${VIRTUAL_DEVICE_PREFIX}${petId}`
}

/**
 * Check if a device ID is a pet-level virtual device
 */
export function isVirtualDevice(deviceId: string | number | undefined): boolean {
  if (!deviceId) return false
  return String(deviceId).startsWith(VIRTUAL_DEVICE_PREFIX)
}

/**
 * Extract pet ID from a pet-level virtual device ID
 */
export function getPetIdFromVirtualDevice(deviceId: string | number): string | null {
  const deviceIdStr = String(deviceId)
  if (!deviceIdStr.startsWith(VIRTUAL_DEVICE_PREFIX)) {
    return null
  }
  return deviceIdStr.replace(VIRTUAL_DEVICE_PREFIX, '')
}
